/* eslint-disable import/first */
import React, { Component } from 'react'
import { Image } from 'react-bootstrap'
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import { setSecureCookie } from "../../utils/secureCookie";
import { primeNotifications } from "../../utils/notificationsStore";
import { primeStudentGlobals } from "../../utils/studentGlobals";
import * as compose from 'lodash.flowright';
import "../components/login_register/_studentLoginNew.scss";
// import Somescripturl from "https://rizee.in/";
import ReactGA from 'react-ga';
import { GoogleAnalyticsArray } from './GoogleAnalytics';
import { tokenChecking } from '../pages/GlobalFunctions';

import logoBlue from '../../images/registrations/logo-blue.png';
import logoWhite from '../../images/registrations/logo-white.png';

const queryParams = new URLSearchParams(window.location.search);
let url_redirect_type = queryParams.get('src');

const LOGIN_USER = gql`
  mutation($username: String!, $password: String) {
    studentLogin(username: $username, password: $password) {
        token
        refreshToken
        user{
            name
            email
            mobile
            valid
            class_id
            exam_id
            exam_name
            current_plan_id
            mobile_verified
            target_year
            videos
            branch_name
            branch_id
            profile_pic
            userlevel
            forum
            institution_id
            institute_name
            institute_logo
            student_user_exam_id

         }
    }
  }
`;

class StudentLogin extends Component {
    constructor(props) {
        super(props);
        var today = new Date();
        var dd = today.getDate();
        var mmm = today.getMonth();
        var month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var yyyy = today.getFullYear();

        var date = new Date();
        var hh = date.getHours();
        var mm = date.getMinutes();
        hh = hh < 10 ? '0' + hh : hh;
        mm = mm < 10 ? '0' + mm : mm;

        let curr_time = hh + ':' + mm;
        today = dd + ' ' + month[mmm] + ' ' + yyyy + ' ' + curr_time;
        this.state = {
            date: today,
            currentStep: 1,
            username: "",
            password: "",
            showPassword: false,
            submitError: "",
            formErrors: {
                username: "",
                password: ""
            },
            usernameValid: false,
            passwordValid: false,
            formValid: false,
            loader: 0,
        };
    }

    componentDidMount = () => {
        /*const scriptTag = document.createElement("script");
        scriptTag.src = "//js.hs-scripts.com/8456667.js";
        scriptTag.async = true;
        document.getElementById("scriptid").appendChild(scriptTag)*/
        const title = GoogleAnalyticsArray[0].Login;
        ReactGA.pageview('/student/login', ["rizee"], title);
        let url = new URL(window.location.href);
        const username = url.searchParams.get('username');
        const password = url.searchParams.get('password');
        // Credentials in a URL end up in browser history, server logs and Referer
        // headers. Partners still link here this way, so the login is kept, but the
        // params are stripped from the address bar before anything else runs.
        // Partners should move off credential URLs (e.g. to a token link).
        if (url.searchParams.has('username') || url.searchParams.has('password')) {
            url.searchParams.delete('username');
            url.searchParams.delete('password');
            window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
        }
        if (username && password && username.length > 0 && password.length > 0) {
            this.login(username, password).catch(error => {
                console.log("catch if error");
                console.log(error);
                this.setState({
                    submitError: error.graphQLErrors.map(x => x.message)
                });
                console.error(
                    "ERR =>",
                    error.graphQLErrors.map(x => x.message)
                );
            });
        }

        if (Cookies.get("student_userlevel") == 1 && Cookies.get("institution_id") != 0 && Cookies.get("user_valid") == 0) {
            this.props.history.push("/student/login");
        } else if (Cookies.get("studenttoken") && tokenChecking(Cookies.get("studenttoken"))
            // Without an enrollment id the loading page sends the student back
            // here, so only skip the login form when there is one.
            && !isNaN(parseInt(Cookies.get("student_user_exam_id")))) {
            this.props.history.push("/student/loading");
            window.location.reload();
        }

    }
    // unmountComponentAtNode = () => {
    //     document.getElementById("scriptid").removeChild("script")
    // }
    datefunction() {

        console.log("date");
    }
    handleFormSubmit = e => {
        e.preventDefault();
        this.setState({
            loader: 1
        });

        if (this.state.formValid) {
            this.login(this.state.username, this.state.password).catch(error => {
                console.log("catch if error");
                console.log(error);
                this.setState({
                    submitError: error.graphQLErrors.map(x => x.message), loader: 0
                });
                console.error("ERR =>", error.graphQLErrors.map(x => x.message));
            });
        } else {
            this.setState({ submitError: "Please fill all the values to proceed", loader: 0 });
        }
    };
    login = async (username, password) => {
        await this.props.login({
            variables: {
                username,
                password
            },
            update: (store, { data }) => {
                // Every student query is keyed on the enrollment id. Without one
                // the app would carry on and fail with 400s, so stop here.
                if (!data.studentLogin.user.student_user_exam_id) {
                    this.setState({ submitError: "No active exam enrollment found for this account. Please contact support.", loader: 0 });
                    return;
                }
                //localStorage.clear();
                setSecureCookie("studenttoken", data.studentLogin.token);
                setSecureCookie("studentrefreshtoken", data.studentLogin.refreshToken);
                setSecureCookie("studentusername", data.studentLogin.user.name);
                // PII no longer stored client-side; the API returns it masked.
                setSecureCookie("institute_name", data.studentLogin.user.institute_name);
                setSecureCookie("institute_logo", data.studentLogin.user.institute_logo);

                // PII no longer stored client-side; the API returns it masked.
                setSecureCookie("classid", data.studentLogin.user.class_id);
                setSecureCookie("examid", data.studentLogin.user.exam_id);
                setSecureCookie("student_user_exam_id", data.studentLogin.user.student_user_exam_id);
                // Load notifications once, here, rather than on every page: the
                // navbar bell reads the result from the store from now on.
                primeNotifications();
                primeStudentGlobals();
                setSecureCookie("exam_name", data.studentLogin.user.exam_name);
                setSecureCookie("mobileverified", data.studentLogin.user.mobile_verified);
                setSecureCookie("targetyear", data.studentLogin.user.target_year);
                setSecureCookie("videos", data.studentLogin.user.videos);
                setSecureCookie("branch_name", data.studentLogin.user.branch_name);
                setSecureCookie("branch_id", data.studentLogin.user.branch_id);
                setSecureCookie("profile_pic", data.studentLogin.user.profile_pic);
                setSecureCookie("student_userlevel", data.studentLogin.user.userlevel);
                setSecureCookie("stulogintype", "normal");
                setSecureCookie("forumlink", data.studentLogin.user.forum);
                setSecureCookie("institution_id", data.studentLogin.user.institution_id);
                setSecureCookie("user_valid", data.studentLogin.user.valid);
                localStorage.removeItem('profile_pic');
                localStorage.removeItem("packageplan");
                localStorage.setItem("packageplan", null);
                localStorage.setItem("profile_pic", data.studentLogin.user.profile_pic);
                localStorage.removeItem("homemodal");
                localStorage.setItem("homemodal", true);
                localStorage.setItem("loginrefermodal", true);
                localStorage.setItem("loginfoundationModal", true)
                setSecureCookie("toggle", "wrapper");
                setSecureCookie("url_redirect_type", url_redirect_type);

                if (data.studentLogin) {
                    if (data.studentLogin.user.valid == "0" && data.studentLogin.user.institution_id == "0") {
                        if (data.studentLogin.user.mobile_verified == "0") {
                            this.props.history.push({
                                pathname: "/student/register",
                                state: {
                                    type: "mobileverify",
                                    fullname: data.studentLogin.user.name,
                                    mobile_mask: data.studentLogin.user.mobile, // masked by the API; display only
                                    email: data.studentLogin.user.email

                                }
                            });
                        }
                        else if (data.studentLogin.user.class_id == "0" ||
                            data.studentLogin.user.exam_id == "0") {
                            this.props.history.push({
                                pathname: "/student/register",
                                state: {
                                    type: "syllabusverify",
                                    fullname: data.studentLogin.user.name,
                                    mobile_mask: data.studentLogin.user.mobile, // masked by the API; display only
                                    email: data.studentLogin.user.email

                                }
                            });
                        }
                        else if (data.studentLogin.user.current_plan_id == "0") {
                            this.props.history.push({
                                pathname: "/student/register",
                                state: {
                                    type: "planverify",
                                    fullname: data.studentLogin.user.name,
                                    mobile_mask: data.studentLogin.user.mobile, // masked by the API; display only
                                    email: data.studentLogin.user.email,
                                    class_id: data.studentLogin.user.class_id,
                                    exam_id: data.studentLogin.user.exam_id,
                                    target_year: data.studentLogin.user.target_year
                                }
                            });
                        }

                        this.setState({ loader: 0 });

                    } else if (data.studentLogin.user.institution_id != "0" && data.studentLogin.user.userlevel == 1 && data.studentLogin.user.valid == 0) {
                        this.props.history.push({
                            pathname: "/student/register",
                            state: {
                                type: "studentBlock",
                            }
                        });
                        this.setState({ loader: 0 });
                    }/*else if (data.studentLogin.user.institution_id == 30){

                        this.props.history.push("exams/test-series-institute");
                        //window.location.reload();
                    }*/
                    else {
                        //this.props.history.push("/student/home");
                        // No window.location.reload() — the auth link reads the token per
                        // request, so a reload isn't needed, and reloading here can feed an
                        // endless login -> loading -> login reload loop.
                        this.props.history.push("/student/loading");
                    }
                }
            }
        });
    };
    handleInputChange = e => {
        const name = e.target.name;
        // Email / mobile number and password never contain spaces; drop them as typed or pasted.
        const value = (name === "username" || name === "password") ? e.target.value.replace(/\s/g, "") : e.target.value;
        this.setState({ [name]: value }, () => {
            this.validateField(name, value);
        });
    };
    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let usernameValid = this.state.usernameValid;
        let passwordValid = this.state.passwordValid;

        switch (fieldName) {
            // case "username":
            //     var pattern = new RegExp(
            //         /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
            //     );

            //     if (value.length < 4) {
            //         usernameValid = false;
            //         fieldValidationErrors.username =
            //             "Username cannot be less than 5 chars";
            //     } else if (!pattern.test(value)) {
            //         usernameValid = false;
            //         fieldValidationErrors.username = "Invalid Username";
            //     } else {
            //         usernameValid = true;
            //         fieldValidationErrors.username = "";
            //     }
            //     break;

            case "username":
                var pattern = new RegExp("^[7-9][0-9]{9}$");

                if (value.length == "") {
                    usernameValid = false;
                    fieldValidationErrors.username = "username Cannot Be Empty";
                }
                // else if (!pattern.test(value)) {
                //     usernameValid = false;
                //     fieldValidationErrors.username = "Invalid username";
                // } 
                else {
                    usernameValid = true;
                    fieldValidationErrors.username = "";
                }

                break;
            case "password":
                if (value.length == "") {
                    passwordValid = false;
                    fieldValidationErrors.password = "Password cannot be Empty";
                } else {
                    passwordValid = true;
                    fieldValidationErrors.password = "";
                }

                break;

            default:
                break;
        }
        this.setState(
            {
                formErrors: fieldValidationErrors,
                usernameValid: usernameValid,
                passwordValid: passwordValid
            },
            this.validateForm
        );
    }

    validateForm() {
        this.setState({
            formValid: this.state.passwordValid && this.state.usernameValid
        });
        if (this.state.formValid) {
            this.setState({ submitError: "" }, () => { });
        }
    }
    togglePassword = () => {
        this.setState((prev) => ({ showPassword: !prev.showPassword }));
    };

    render() {
        const { formErrors, submitError, loader, currentStep, showPassword } = this.state;
        const highlights = [
            { icon: "fas fa-file-alt", title: "Previous paper analysis", text: "Practise on real papers and see exactly where marks slip." },
            { icon: "fas fa-book-open", title: "Personalised revision", text: "Revision material built from your own weak chapters." },
            { icon: "fas fa-university", title: "College & branch predictor", text: "Know where your rank can take you before counselling." },
        ];
        const errorText = Array.isArray(submitError) ? submitError.join(" ") : submitError;

        return (
            <div className="sl-page">
                <aside className="sl-brand">
                    <a className="sl-brand__logo" href="https://rizee.in/">
                        <Image src={logoWhite} alt="Rizee" />
                    </a>
                    <div className="sl-brand__body">
                        <h1 className="sl-brand__title">
                            Crack NEET, JEE &amp; EAMCET <span>with a plan.</span>
                        </h1>
                        <p className="sl-brand__lead">
                            Your perfect preparation guide. Learn, practise, analyse and get ready for your exam.
                        </p>
                        <ul className="sl-points">
                            {highlights.map((h) => (
                                <li key={h.title} className="sl-point">
                                    <span className="sl-point__icon"><i className={h.icon} aria-hidden="true"></i></span>
                                    <span>
                                        <strong>{h.title}</strong>
                                        <small>{h.text}</small>
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <p className="sl-brand__foot">Plan · Execute · Measure · Warm up</p>
                </aside>

                <main className="sl-main">
                    <div className="sl-card">
                        <a className="sl-card__logo" href="https://rizee.in/">
                            <Image src={logoBlue} alt="Rizee" />
                        </a>
                        <h2 className="sl-card__title">Welcome back</h2>
                        <p className="sl-card__sub">Log in to continue your preparation.</p>

                        {currentStep == 5 ? (
                            <div className="sl-alert sl-alert--ok" role="status">Logged in successfully</div>
                        ) : errorText ? (
                            <div className="sl-alert" role="alert">
                                <i className="fas fa-exclamation-circle" aria-hidden="true"></i> {errorText}
                            </div>
                        ) : null}

                        <form className="sl-form" onSubmit={this.handleFormSubmit} noValidate>
                            <div className={`sl-field${formErrors.username ? " sl-field--error" : ""}`}>
                                <label htmlFor="sl-username">Email or mobile number</label>
                                <div className="sl-input">
                                    <i className="far fa-user" aria-hidden="true"></i>
                                    <input
                                        id="sl-username"
                                        type="text"
                                        name="username"
                                        autoComplete="username"
                                        placeholder="you@example.com or 98xxxxxxxx"
                                        onChange={this.handleInputChange}
                                        aria-invalid={!!formErrors.username}
                                    />
                                </div>
                                {formErrors.username && <span className="sl-field__msg">{formErrors.username}</span>}
                            </div>

                            <div className={`sl-field${formErrors.password ? " sl-field--error" : ""}`}>
                                <div className="sl-field__row">
                                    <label htmlFor="sl-password">Password</label>
                                    <Link className="sl-link" to="/student/ForgotPassword">Forgot password?</Link>
                                </div>
                                <div className="sl-input">
                                    <i className="fas fa-lock" aria-hidden="true"></i>
                                    <input
                                        id="sl-password"
                                        type={showPassword ? "text" : "password"}
                                        name="password"
                                        autoComplete="current-password"
                                        placeholder="Enter your password"
                                        onChange={this.handleInputChange}
                                        aria-invalid={!!formErrors.password}
                                    />
                                    <button
                                        type="button"
                                        className="sl-input__toggle"
                                        onClick={this.togglePassword}
                                        aria-label={showPassword ? "Hide password" : "Show password"}
                                    >
                                        <i className={showPassword ? "far fa-eye-slash" : "far fa-eye"} aria-hidden="true"></i>
                                    </button>
                                </div>
                                {formErrors.password && <span className="sl-field__msg">{formErrors.password}</span>}
                            </div>

                            <button type="submit" className="sl-submit" disabled={loader == 1}>
                                {loader == 1 ? (
                                    <><span className="spinner-border spinner-border-sm" aria-hidden="true"></span> Logging in…</>
                                ) : "Log in"}
                            </button>
                        </form>

                        <p className="sl-card__foot">
                            New to Rizee? <a className="sl-link" href="https://rizee.in/Registration/?src=website">Create an account</a>
                        </p>
                    </div>
                </main>
            </div>
        )
    }
}

export default withRouter(compose(
    graphql(LOGIN_USER, {
        name: "login"
    })
)(StudentLogin)
);